<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="row">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'trello'" size="19" class="mr-05"></span>
            <div class="card-title">{{ "MENU.WORKDAY_USER_REPORT" | translate }}</div>
          </div>
          <div class="card-body">
            <div class="mb-075">
              <a [routerLink]="'/dashboard/configurations/report-unlock-day'">{{ "CONFIGURATIONS.MANAGE_REPORT_UNLOCK_DAY" | translate }}</a>
            </div>
            <div class="mb-075">
              <span class="text-primary cursor-pointer" (click)="modalOpen(workDayWeek)">{{ "CONFIGURATIONS.MANAGE_WORKDAY_WEEK" | translate }}</span>
            </div>
            <div class="mb-075">
              <span class="text-primary cursor-pointer" (click)="modalOpen(setDaysUnlockReport)">{{ "CONFIGURATIONS.SET_REPORT_UNLOCK_DAY" | translate }}</span>
            </div>
          </div>
        </div>
        <div class="card" *ngIf="_utilsService.themeConfiguration.installed_packages.includes('job-position')">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'briefcase'" size="19" class="mr-05"></span>
            <div class="card-title">{{ "TITLES.JOB_POSITIONS" | translate }}</div>
          </div>
          <div class="card-body">
            <div class="mb-075">
              <span class="text-primary cursor-pointer" (click)="modalOpen(editDescriptionJobPositions)">{{ "CONFIGURATIONS.EDIT_DESCRIPTION_JOB_POSITIONS" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'dollar-sign'" size="19" class="mr-05"></span>
            <div class="card-title">{{ "COSTS" | translate }}</div>
          </div>
          <div class="card-body">
            <div class="mb-075">
              <span class="text-primary cursor-pointer" (click)="modalOpen(setMarginRequest)">{{ "CONFIGURATIONS.SET_MARGIN_REQUEST" | translate }}</span>
            </div>
            <div class="mb-075">
              <span class="text-primary cursor-pointer" (click)="modalOpen(setMarginCommissionProfit)">{{ "CONFIGURATIONS.SET_MARGIN_PROFIT" | translate }}</span>
            </div>
            <div class="mb-075">
              <span class="text-primary cursor-pointer" (click)="modalOpen(setMarginCommissionCost)">{{ "CONFIGURATIONS.SET_MARGIN_COST" | translate }}</span>
            </div>
            <div class="mb-075">
              <span class="text-primary cursor-pointer" (click)="modalOpen(setEvidenceCommission)">{{ "CONFIGURATIONS.SET_EVIDENCE_COST" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'file-text'" size="19" class="mr-05"></span>
            <div class="card-title">{{ "MENU.COMMISSION" | translate }}</div>
          </div>
          <div class="card-body">
            <div class="mb-075">
              <a routerLink="/dashboard/deals/edit-template-paragraphs">{{ "CONFIGURATIONS.EDIT_PARAGRAPHS_DEALS" | translate }}</a>
            </div>
            <div class="mb-075">
              <span class="text-primary cursor-pointer" (click)="modalOpen(setRetroActiveDate)">{{ "CONFIGURATIONS.SET_INPUT_DATE_RETROACTIVE" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal workday week -->
<ng-template #workDayWeek let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3 class="mb-1">{{ "CONFIGURATIONS.MANAGE_WORKDAY_WEEK" | translate }}</h3>
    <div class="custom-control custom-checkbox mb-075" *ngFor="let item of weekSetup; let i = index">
      <span class="mr-2">{{ item.name | titlecase }}</span>
      <input type="checkbox" class="custom-control-input" [id]="'day_' + i" [(ngModel)]="item.isWorkDay" [ngModelOptions]="{ standalone: true }" />
      <label class="custom-control-label" [for]="'day_' + i" *ngIf="item.isWorkDay">{{ "WORKING" | translate }}</label>
      <label class="custom-control-label" [for]="'day_' + i" *ngIf="!item.isWorkDay">{{ "HOLIDAY" | translate }}</label>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" (click)="saveWorkDay()" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal workday week -->

<!-- Modal setDaysUnlockReport -->
<ng-template #setDaysUnlockReport let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3 class="mb-1">{{ "CONFIGURATIONS.SET_REPORT_UNLOCK_DAY" | translate }}</h3>
    <p>{{ "CONFIGURATIONS.EXPLICATION_UNLOCK_DAY" | translate }}</p>
    <div>
      <label for="daysUnlockReport">{{ "NUMBER_OF_DAY" | translate }}</label>
      <input type="number" (change)="controlValue()" [max]="20" [min]="1" [maxLength]="2" name="daysUnlockReport" id="daysUnlockReport" [(ngModel)]="daysUnlockReport" class="form-control" />
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" (click)="saveDaysUnlockReport()" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal setDaysUnlockReport -->

<!-- Modal setMarginRequest -->
<ng-template #setMarginRequest let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3 class="mb-1">{{ "CONFIGURATIONS.SET_MARGIN_REQUEST" | translate }}</h3>
    <p>{{ "CONFIGURATIONS.SET_MARGIN_FOR_REQUEST" | translate }}</p>
    <div>
      <label for="marginRequest">{{ "REQUEST_MARGIN" | translate }}</label>
      <input type="number" [min]="1" [maxLength]="2" name="marginRequest" id="marginRequest" [(ngModel)]="marginRequest" class="form-control" />
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" (click)="saveMarginRequest()" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal setMarginRequest -->

<!-- Modal setMarginCommissionProfit -->
<ng-template #setMarginCommissionProfit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3 class="mb-1">{{ "CONFIGURATIONS.SET_MARGIN_PROFIT" | translate }}</h3>
    <p>{{ "CONFIGURATIONS.SET_MARGIN_FOR_PROFIT" | translate }}</p>
    <div>
      <label for="marginCommissionProfit">{{ "PROFIT_MARGIN" | translate }}</label>
      <input type="number" [min]="1" [maxLength]="2" name="marginCommissionProfit" id="marginCommissionProfit" [(ngModel)]="marginCommissionProfit" class="form-control" />
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" (click)="saveMarginCommissionProfit()" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal setMarginCommissionProfit -->

<!-- Modal setMarginCommissionCost -->
<ng-template #setMarginCommissionCost let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3 class="mb-1">{{ "CONFIGURATIONS.SET_MARGIN_COST" | translate }}</h3>
    <p>{{ "CONFIGURATIONS.SET_MARGIN_FOR_COST" | translate }}</p>
    <div>
      <label for="marginCommissionCost">{{ "COST_MARGIN" | translate }}</label>
      <input type="number" [min]="1" [maxLength]="2" name="marginCommissionCost" id="marginCommissionCost" [(ngModel)]="marginCommissionCost" class="form-control" />
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" (click)="saveMarginCommissionCost()" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal setMarginCommissionCost -->

<!-- Modal editDescriptionJobPositions -->
<ng-template #editDescriptionJobPositions let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3 class="mb-1">{{ "CONFIGURATIONS.EDIT_DESCRIPTION_JOB_POSITIONS" | translate }}</h3>
    <p>{{ "CONFIGURATIONS.EDIT_DESCRIPTION_JOB_POSITIONS_MESSAGE" | translate }}</p>
    <div class="row">
      <div class="col-12">
        <label for="summary">{{ "OPENING_DESCRIPTION" | translate }}:</label>
        <angular-editor id="summary" [config]="_utilsService.defaultEditorConfig" [(ngModel)]="jobPosition.opening_description"></angular-editor>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <label for="description">{{ "CLOSURE_DESCRIPTION" | translate }}:</label>
        <angular-editor id="description" [config]="_utilsService.defaultEditorConfig" [(ngModel)]="jobPosition.closure_description"></angular-editor>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" (click)="setDescriptionJobPositions()" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal editDescriptionJobPositions -->

<!-- Modal setRetroActiveDate -->
<ng-template #setRetroActiveDate let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3 class="mb-1">{{ "CONFIGURATIONS.SET_INPUT_DATE_RETROACTIVE" | translate }}</h3>
    <p>{{ "CONFIGURATIONS.SET_INPUT_DATE_RETROACTIVE_MESSAGE" | translate }}</p>
    <div class="d-flex align-items-center">
      <label for="retroActiveDate" class="mr-075 mb-0" *ngIf="retroActiveDate">{{ "ACTIVE" | translate }}</label>
      <label for="retroActiveDate" class="mr-075 mb-0" *ngIf="!retroActiveDate">{{ "DEACTIVATED" | translate }}</label>
      <div class="custom-control custom-control-primary custom-switch w-fit ml-1">
        <input id="retroActiveDate" type="checkbox" checked class="custom-control-input" [(ngModel)]="retroActiveDate" />
        <label class="custom-control-label" for="retroActiveDate"></label>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" (click)="setRetroActive()" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal setRetroActiveDate -->

<!-- Modal setEvidenceCommission -->
<ng-template #setEvidenceCommission let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3 class="mb-1">{{ "CONFIGURATIONS.SET_EVIDENCE_COST" | translate }}</h3>
    <p>{{ "CONFIGURATIONS.SET_EVIDENCE_COST_MESSAGE" | translate }}</p>
    <div>
      <label for="evidenceCost">{{ "COST" | translate }}</label>
      <ng-select
        id="evidenceCost"
        bindLabel="description"
        bindValue="id"
        [(ngModel)]="evidenceCost"
        [multiple]="false"
        [searchable]="true"
        [closeOnSelect]="true"
        [clearable]="false"
        [openOnEnter]="false"
        [virtualScroll]="true"
        [items]="costsList"
      ></ng-select>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" (click)="sendEvidenceCommission()" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal setEvidenceCommission -->
